import { useFormikContext } from "formik";
import { useEffect } from "react";

export function ScrollToFormError() {
  const formik = useFormikContext();
  const submitting = formik?.isSubmitting;

  // This will need an update if new form components come into use
  useEffect(() => {
    const errorLabel = document.querySelector(".FormFieldError-text");
    (errorLabel?.parentElement ?? errorLabel)?.scrollIntoView();
  }, [submitting]);
  return null;
}
